import * as Te from "react";
import Tr, { forwardRef as qe, useContext as yn, useMemo as ce, useRef as tr, useState as Ce, useEffect as De, useCallback as Le, Children as bn } from "react";
import { css as p } from "@emotion/react";
import { globalColor as L, illaPrefix as F, getColor as nr, zIndex as gn, applyBoxStyle as xn, deleteCssProps as En } from "@illa-design/theme";
import { CloseIcon as Cn, UpIcon as ht, DownIcon as vt, PreviousIcon as mt, NextIcon as yt, AddIcon as wn } from "@illa-design/icon";
import bt from "react-use-measure";
import { isObject as qr } from "@illa-design/system";
var xr = { exports: {} }, Ve = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gr;
function Sn() {
  if (Gr)
    return Ve;
  Gr = 1;
  var e = Tr, r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(u, f, m) {
    var h, x = {}, T = null, b = null;
    m !== void 0 && (T = "" + m), f.key !== void 0 && (T = "" + f.key), f.ref !== void 0 && (b = f.ref);
    for (h in f)
      n.call(f, h) && !i.hasOwnProperty(h) && (x[h] = f[h]);
    if (u && u.defaultProps)
      for (h in f = u.defaultProps, f)
        x[h] === void 0 && (x[h] = f[h]);
    return { $$typeof: r, type: u, key: T, ref: b, props: x, _owner: a.current };
  }
  return Ve.Fragment = t, Ve.jsx = s, Ve.jsxs = s, Ve;
}
var Ye = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jr;
function _n() {
  return Jr || (Jr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Tr, r = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), u = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), x = Symbol.for("react.memo"), T = Symbol.for("react.lazy"), b = Symbol.for("react.offscreen"), g = Symbol.iterator, E = "@@iterator";
    function z(o) {
      if (o === null || typeof o != "object")
        return null;
      var c = g && o[g] || o[E];
      return typeof c == "function" ? c : null;
    }
    var $ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(o) {
      {
        for (var c = arguments.length, d = new Array(c > 1 ? c - 1 : 0), w = 1; w < c; w++)
          d[w - 1] = arguments[w];
        v("error", o, d);
      }
    }
    function v(o, c, d) {
      {
        var w = $.ReactDebugCurrentFrame, N = w.getStackAddendum();
        N !== "" && (c += "%s", d = d.concat([N]));
        var B = d.map(function(R) {
          return String(R);
        });
        B.unshift("Warning: " + c), Function.prototype.apply.call(console[o], console, B);
      }
    }
    var C = !1, l = !1, j = !1, P = !1, ge = !1, ae;
    ae = Symbol.for("react.module.reference");
    function V(o) {
      return !!(typeof o == "string" || typeof o == "function" || o === n || o === i || ge || o === a || o === m || o === h || P || o === b || C || l || j || typeof o == "object" && o !== null && (o.$$typeof === T || o.$$typeof === x || o.$$typeof === s || o.$$typeof === u || o.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      o.$$typeof === ae || o.getModuleId !== void 0));
    }
    function me(o, c, d) {
      var w = o.displayName;
      if (w)
        return w;
      var N = c.displayName || c.name || "";
      return N !== "" ? d + "(" + N + ")" : d;
    }
    function ye(o) {
      return o.displayName || "Context";
    }
    function S(o) {
      if (o == null)
        return null;
      if (typeof o.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof o == "function")
        return o.displayName || o.name || null;
      if (typeof o == "string")
        return o;
      switch (o) {
        case n:
          return "Fragment";
        case t:
          return "Portal";
        case i:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case u:
            var c = o;
            return ye(c) + ".Consumer";
          case s:
            var d = o;
            return ye(d._context) + ".Provider";
          case f:
            return me(o, o.render, "ForwardRef");
          case x:
            var w = o.displayName || null;
            return w !== null ? w : S(o.type) || "Memo";
          case T: {
            var N = o, B = N._payload, R = N._init;
            try {
              return S(R(B));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, Q = 0, ie, le, fe, de, U, Y, ee;
    function re() {
    }
    re.__reactDisabledLog = !0;
    function pe() {
      {
        if (Q === 0) {
          ie = console.log, le = console.info, fe = console.warn, de = console.error, U = console.group, Y = console.groupCollapsed, ee = console.groupEnd;
          var o = {
            configurable: !0,
            enumerable: !0,
            value: re,
            writable: !0
          };
          Object.defineProperties(console, {
            info: o,
            log: o,
            warn: o,
            error: o,
            group: o,
            groupCollapsed: o,
            groupEnd: o
          });
        }
        Q++;
      }
    }
    function H() {
      {
        if (Q--, Q === 0) {
          var o = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, o, {
              value: ie
            }),
            info: Z({}, o, {
              value: le
            }),
            warn: Z({}, o, {
              value: fe
            }),
            error: Z({}, o, {
              value: de
            }),
            group: Z({}, o, {
              value: U
            }),
            groupCollapsed: Z({}, o, {
              value: Y
            }),
            groupEnd: Z({}, o, {
              value: ee
            })
          });
        }
        Q < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var W = $.ReactCurrentDispatcher, J;
    function ne(o, c, d) {
      {
        if (J === void 0)
          try {
            throw Error();
          } catch (N) {
            var w = N.stack.trim().match(/\n( *(at )?)/);
            J = w && w[1] || "";
          }
        return `
` + J + o;
      }
    }
    var xe = !1, Ae;
    {
      var pr = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new pr();
    }
    function y(o, c) {
      if (!o || xe)
        return "";
      {
        var d = Ae.get(o);
        if (d !== void 0)
          return d;
      }
      var w;
      xe = !0;
      var N = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var B;
      B = W.current, W.current = null, pe();
      try {
        if (c) {
          var R = function() {
            throw Error();
          };
          if (Object.defineProperty(R.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(R, []);
            } catch (Se) {
              w = Se;
            }
            Reflect.construct(o, [], R);
          } else {
            try {
              R.call();
            } catch (Se) {
              w = Se;
            }
            o.call(R.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Se) {
            w = Se;
          }
          o();
        }
      } catch (Se) {
        if (Se && w && typeof Se.stack == "string") {
          for (var O = Se.stack.split(`
`), oe = w.stack.split(`
`), K = O.length - 1, q = oe.length - 1; K >= 1 && q >= 0 && O[K] !== oe[q]; )
            q--;
          for (; K >= 1 && q >= 0; K--, q--)
            if (O[K] !== oe[q]) {
              if (K !== 1 || q !== 1)
                do
                  if (K--, q--, q < 0 || O[K] !== oe[q]) {
                    var he = `
` + O[K].replace(" at new ", " at ");
                    return o.displayName && he.includes("<anonymous>") && (he = he.replace("<anonymous>", o.displayName)), typeof o == "function" && Ae.set(o, he), he;
                  }
                while (K >= 1 && q >= 0);
              break;
            }
        }
      } finally {
        xe = !1, W.current = B, H(), Error.prepareStackTrace = N;
      }
      var Ie = o ? o.displayName || o.name : "", Ur = Ie ? ne(Ie) : "";
      return typeof o == "function" && Ae.set(o, Ur), Ur;
    }
    function je(o, c, d) {
      return y(o, !1);
    }
    function Ne(o) {
      var c = o.prototype;
      return !!(c && c.isReactComponent);
    }
    function Oe(o, c, d) {
      if (o == null)
        return "";
      if (typeof o == "function")
        return y(o, Ne(o));
      if (typeof o == "string")
        return ne(o);
      switch (o) {
        case m:
          return ne("Suspense");
        case h:
          return ne("SuspenseList");
      }
      if (typeof o == "object")
        switch (o.$$typeof) {
          case f:
            return je(o.render);
          case x:
            return Oe(o.type, c, d);
          case T: {
            var w = o, N = w._payload, B = w._init;
            try {
              return Oe(B(N), c, d);
            } catch {
            }
          }
        }
      return "";
    }
    var Je = Object.prototype.hasOwnProperty, Dr = {}, Mr = $.ReactDebugCurrentFrame;
    function Ze(o) {
      if (o) {
        var c = o._owner, d = Oe(o.type, o._source, c ? c.type : null);
        Mr.setExtraStackFrame(d);
      } else
        Mr.setExtraStackFrame(null);
    }
    function Jt(o, c, d, w, N) {
      {
        var B = Function.call.bind(Je);
        for (var R in o)
          if (B(o, R)) {
            var O = void 0;
            try {
              if (typeof o[R] != "function") {
                var oe = Error((w || "React class") + ": " + d + " type `" + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[R] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw oe.name = "Invariant Violation", oe;
              }
              O = o[R](c, R, w, d, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (K) {
              O = K;
            }
            O && !(O instanceof Error) && (Ze(N), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", w || "React class", d, R, typeof O), Ze(null)), O instanceof Error && !(O.message in Dr) && (Dr[O.message] = !0, Ze(N), _("Failed %s type: %s", d, O.message), Ze(null));
          }
      }
    }
    var Zt = Array.isArray;
    function hr(o) {
      return Zt(o);
    }
    function Xt(o) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, d = c && o[Symbol.toStringTag] || o.constructor.name || "Object";
        return d;
      }
    }
    function Qt(o) {
      try {
        return Lr(o), !1;
      } catch {
        return !0;
      }
    }
    function Lr(o) {
      return "" + o;
    }
    function Fr(o) {
      if (Qt(o))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Xt(o)), Lr(o);
    }
    var Be = $.ReactCurrentOwner, en = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, zr, jr, vr;
    vr = {};
    function rn(o) {
      if (Je.call(o, "ref")) {
        var c = Object.getOwnPropertyDescriptor(o, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return o.ref !== void 0;
    }
    function tn(o) {
      if (Je.call(o, "key")) {
        var c = Object.getOwnPropertyDescriptor(o, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return o.key !== void 0;
    }
    function nn(o, c) {
      if (typeof o.ref == "string" && Be.current && c && Be.current.stateNode !== c) {
        var d = S(Be.current.type);
        vr[d] || (_('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', S(Be.current.type), o.ref), vr[d] = !0);
      }
    }
    function on(o, c) {
      {
        var d = function() {
          zr || (zr = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        d.isReactWarning = !0, Object.defineProperty(o, "key", {
          get: d,
          configurable: !0
        });
      }
    }
    function an(o, c) {
      {
        var d = function() {
          jr || (jr = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        d.isReactWarning = !0, Object.defineProperty(o, "ref", {
          get: d,
          configurable: !0
        });
      }
    }
    var sn = function(o, c, d, w, N, B, R) {
      var O = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: o,
        key: c,
        ref: d,
        props: R,
        // Record the component responsible for creating this element.
        _owner: B
      };
      return O._store = {}, Object.defineProperty(O._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(O, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.defineProperty(O, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: N
      }), Object.freeze && (Object.freeze(O.props), Object.freeze(O)), O;
    };
    function cn(o, c, d, w, N) {
      {
        var B, R = {}, O = null, oe = null;
        d !== void 0 && (Fr(d), O = "" + d), tn(c) && (Fr(c.key), O = "" + c.key), rn(c) && (oe = c.ref, nn(c, N));
        for (B in c)
          Je.call(c, B) && !en.hasOwnProperty(B) && (R[B] = c[B]);
        if (o && o.defaultProps) {
          var K = o.defaultProps;
          for (B in K)
            R[B] === void 0 && (R[B] = K[B]);
        }
        if (O || oe) {
          var q = typeof o == "function" ? o.displayName || o.name || "Unknown" : o;
          O && on(R, q), oe && an(R, q);
        }
        return sn(o, O, oe, N, w, Be.current, R);
      }
    }
    var mr = $.ReactCurrentOwner, Br = $.ReactDebugCurrentFrame;
    function ke(o) {
      if (o) {
        var c = o._owner, d = Oe(o.type, o._source, c ? c.type : null);
        Br.setExtraStackFrame(d);
      } else
        Br.setExtraStackFrame(null);
    }
    var yr;
    yr = !1;
    function br(o) {
      return typeof o == "object" && o !== null && o.$$typeof === r;
    }
    function Vr() {
      {
        if (mr.current) {
          var o = S(mr.current.type);
          if (o)
            return `

Check the render method of \`` + o + "`.";
        }
        return "";
      }
    }
    function un(o) {
      {
        if (o !== void 0) {
          var c = o.fileName.replace(/^.*[\\\/]/, ""), d = o.lineNumber;
          return `

Check your code at ` + c + ":" + d + ".";
        }
        return "";
      }
    }
    var Yr = {};
    function ln(o) {
      {
        var c = Vr();
        if (!c) {
          var d = typeof o == "string" ? o : o.displayName || o.name;
          d && (c = `

Check the top-level render call using <` + d + ">.");
        }
        return c;
      }
    }
    function Hr(o, c) {
      {
        if (!o._store || o._store.validated || o.key != null)
          return;
        o._store.validated = !0;
        var d = ln(c);
        if (Yr[d])
          return;
        Yr[d] = !0;
        var w = "";
        o && o._owner && o._owner !== mr.current && (w = " It was passed a child from " + S(o._owner.type) + "."), ke(o), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', d, w), ke(null);
      }
    }
    function Wr(o, c) {
      {
        if (typeof o != "object")
          return;
        if (hr(o))
          for (var d = 0; d < o.length; d++) {
            var w = o[d];
            br(w) && Hr(w, c);
          }
        else if (br(o))
          o._store && (o._store.validated = !0);
        else if (o) {
          var N = z(o);
          if (typeof N == "function" && N !== o.entries)
            for (var B = N.call(o), R; !(R = B.next()).done; )
              br(R.value) && Hr(R.value, c);
        }
      }
    }
    function fn(o) {
      {
        var c = o.type;
        if (c == null || typeof c == "string")
          return;
        var d;
        if (typeof c == "function")
          d = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === x))
          d = c.propTypes;
        else
          return;
        if (d) {
          var w = S(c);
          Jt(d, o.props, "prop", w, o);
        } else if (c.PropTypes !== void 0 && !yr) {
          yr = !0;
          var N = S(c);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", N || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function dn(o) {
      {
        for (var c = Object.keys(o.props), d = 0; d < c.length; d++) {
          var w = c[d];
          if (w !== "children" && w !== "key") {
            ke(o), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", w), ke(null);
            break;
          }
        }
        o.ref !== null && (ke(o), _("Invalid attribute `ref` supplied to `React.Fragment`."), ke(null));
      }
    }
    function Kr(o, c, d, w, N, B) {
      {
        var R = V(o);
        if (!R) {
          var O = "";
          (o === void 0 || typeof o == "object" && o !== null && Object.keys(o).length === 0) && (O += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var oe = un(N);
          oe ? O += oe : O += Vr();
          var K;
          o === null ? K = "null" : hr(o) ? K = "array" : o !== void 0 && o.$$typeof === r ? (K = "<" + (S(o.type) || "Unknown") + " />", O = " Did you accidentally export a JSX literal instead of a component?") : K = typeof o, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K, O);
        }
        var q = cn(o, c, d, N, B);
        if (q == null)
          return q;
        if (R) {
          var he = c.children;
          if (he !== void 0)
            if (w)
              if (hr(he)) {
                for (var Ie = 0; Ie < he.length; Ie++)
                  Wr(he[Ie], o);
                Object.freeze && Object.freeze(he);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Wr(he, o);
        }
        return o === n ? dn(q) : fn(q), q;
      }
    }
    function pn(o, c, d) {
      return Kr(o, c, d, !0);
    }
    function hn(o, c, d) {
      return Kr(o, c, d, !1);
    }
    var vn = hn, mn = pn;
    Ye.Fragment = n, Ye.jsx = vn, Ye.jsxs = mn;
  }()), Ye;
}
process.env.NODE_ENV === "production" ? xr.exports = Sn() : xr.exports = _n();
var or = xr.exports;
function Tn(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function $n(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var Pn = /* @__PURE__ */ function() {
  function e(t) {
    var n = this;
    this._insertTag = function(a) {
      var i;
      n.tags.length === 0 ? n.insertionPoint ? i = n.insertionPoint.nextSibling : n.prepend ? i = n.container.firstChild : i = n.before : i = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(a, i), n.tags.push(a);
    }, this.isSpeedy = t.speedy === void 0 ? process.env.NODE_ENV === "production" : t.speedy, this.tags = [], this.ctr = 0, this.nonce = t.nonce, this.key = t.key, this.container = t.container, this.prepend = t.prepend, this.insertionPoint = t.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, r.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag($n(this));
    var a = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = n.charCodeAt(0) === 64 && n.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + n + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var s = Tn(a);
      try {
        s.insertRule(n, s.cssRules.length);
      } catch (u) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(n) && console.error('There was a problem inserting the following rule: "' + n + '"', u);
      }
    } else
      a.appendChild(document.createTextNode(n));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(n) {
      return n.parentNode && n.parentNode.removeChild(n);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), te = "-ms-", ar = "-moz-", k = "-webkit-", $r = "comm", Pr = "rule", Or = "decl", On = "@import", gt = "@keyframes", Rn = "@layer", An = Math.abs, cr = String.fromCharCode, Nn = Object.assign;
function kn(e, r) {
  return X(e, 0) ^ 45 ? (((r << 2 ^ X(e, 0)) << 2 ^ X(e, 1)) << 2 ^ X(e, 2)) << 2 ^ X(e, 3) : 0;
}
function xt(e) {
  return e.trim();
}
function In(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function I(e, r, t) {
  return e.replace(r, t);
}
function Er(e, r) {
  return e.indexOf(r);
}
function X(e, r) {
  return e.charCodeAt(r) | 0;
}
function We(e, r, t) {
  return e.slice(r, t);
}
function Ee(e) {
  return e.length;
}
function Rr(e) {
  return e.length;
}
function Xe(e, r) {
  return r.push(e), e;
}
function Dn(e, r) {
  return e.map(r).join("");
}
var ur = 1, Fe = 1, Et = 0, se = 0, G = 0, ze = "";
function lr(e, r, t, n, a, i, s) {
  return { value: e, root: r, parent: t, type: n, props: a, children: i, line: ur, column: Fe, length: s, return: "" };
}
function He(e, r) {
  return Nn(lr("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Mn() {
  return G;
}
function Ln() {
  return G = se > 0 ? X(ze, --se) : 0, Fe--, G === 10 && (Fe = 1, ur--), G;
}
function ue() {
  return G = se < Et ? X(ze, se++) : 0, Fe++, G === 10 && (Fe = 1, ur++), G;
}
function we() {
  return X(ze, se);
}
function Qe() {
  return se;
}
function Ge(e, r) {
  return We(ze, e, r);
}
function Ke(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Ct(e) {
  return ur = Fe = 1, Et = Ee(ze = e), se = 0, [];
}
function wt(e) {
  return ze = "", e;
}
function er(e) {
  return xt(Ge(se - 1, Cr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Fn(e) {
  for (; (G = we()) && G < 33; )
    ue();
  return Ke(e) > 2 || Ke(G) > 3 ? "" : " ";
}
function zn(e, r) {
  for (; --r && ue() && !(G < 48 || G > 102 || G > 57 && G < 65 || G > 70 && G < 97); )
    ;
  return Ge(e, Qe() + (r < 6 && we() == 32 && ue() == 32));
}
function Cr(e) {
  for (; ue(); )
    switch (G) {
      case e:
        return se;
      case 34:
      case 39:
        e !== 34 && e !== 39 && Cr(G);
        break;
      case 40:
        e === 41 && Cr(e);
        break;
      case 92:
        ue();
        break;
    }
  return se;
}
function jn(e, r) {
  for (; ue() && e + G !== 47 + 10; )
    if (e + G === 42 + 42 && we() === 47)
      break;
  return "/*" + Ge(r, se - 1) + "*" + cr(e === 47 ? e : ue());
}
function Bn(e) {
  for (; !Ke(we()); )
    ue();
  return Ge(e, se);
}
function Vn(e) {
  return wt(rr("", null, null, null, [""], e = Ct(e), 0, [0], e));
}
function rr(e, r, t, n, a, i, s, u, f) {
  for (var m = 0, h = 0, x = s, T = 0, b = 0, g = 0, E = 1, z = 1, $ = 1, _ = 0, v = "", C = a, l = i, j = n, P = v; z; )
    switch (g = _, _ = ue()) {
      case 40:
        if (g != 108 && X(P, x - 1) == 58) {
          Er(P += I(er(_), "&", "&\f"), "&\f") != -1 && ($ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += er(_);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += Fn(g);
        break;
      case 92:
        P += zn(Qe() - 1, 7);
        continue;
      case 47:
        switch (we()) {
          case 42:
          case 47:
            Xe(Yn(jn(ue(), Qe()), r, t), f);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * E:
        u[m++] = Ee(P) * $;
      case 125 * E:
      case 59:
      case 0:
        switch (_) {
          case 0:
          case 125:
            z = 0;
          case 59 + h:
            $ == -1 && (P = I(P, /\f/g, "")), b > 0 && Ee(P) - x && Xe(b > 32 ? Xr(P + ";", n, t, x - 1) : Xr(I(P, " ", "") + ";", n, t, x - 2), f);
            break;
          case 59:
            P += ";";
          default:
            if (Xe(j = Zr(P, r, t, m, h, a, u, v, C = [], l = [], x), i), _ === 123)
              if (h === 0)
                rr(P, r, j, j, C, i, x, u, l);
              else
                switch (T === 99 && X(P, 3) === 110 ? 100 : T) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    rr(e, j, j, n && Xe(Zr(e, j, j, 0, 0, a, u, v, a, C = [], x), l), a, l, x, u, n ? C : l);
                    break;
                  default:
                    rr(P, j, j, j, [""], l, 0, u, l);
                }
        }
        m = h = b = 0, E = $ = 1, v = P = "", x = s;
        break;
      case 58:
        x = 1 + Ee(P), b = g;
      default:
        if (E < 1) {
          if (_ == 123)
            --E;
          else if (_ == 125 && E++ == 0 && Ln() == 125)
            continue;
        }
        switch (P += cr(_), _ * E) {
          case 38:
            $ = h > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            u[m++] = (Ee(P) - 1) * $, $ = 1;
            break;
          case 64:
            we() === 45 && (P += er(ue())), T = we(), h = x = Ee(v = P += Bn(Qe())), _++;
            break;
          case 45:
            g === 45 && Ee(P) == 2 && (E = 0);
        }
    }
  return i;
}
function Zr(e, r, t, n, a, i, s, u, f, m, h) {
  for (var x = a - 1, T = a === 0 ? i : [""], b = Rr(T), g = 0, E = 0, z = 0; g < n; ++g)
    for (var $ = 0, _ = We(e, x + 1, x = An(E = s[g])), v = e; $ < b; ++$)
      (v = xt(E > 0 ? T[$] + " " + _ : I(_, /&\f/g, T[$]))) && (f[z++] = v);
  return lr(e, r, t, a === 0 ? Pr : u, f, m, h);
}
function Yn(e, r, t) {
  return lr(e, r, t, $r, cr(Mn()), We(e, 2, -2), 0);
}
function Xr(e, r, t, n) {
  return lr(e, r, t, Or, We(e, 0, n), We(e, n + 1, -1), n);
}
function Me(e, r) {
  for (var t = "", n = Rr(e), a = 0; a < n; a++)
    t += r(e[a], a, e, r) || "";
  return t;
}
function Hn(e, r, t, n) {
  switch (e.type) {
    case Rn:
      if (e.children.length)
        break;
    case On:
    case Or:
      return e.return = e.return || e.value;
    case $r:
      return "";
    case gt:
      return e.return = e.value + "{" + Me(e.children, n) + "}";
    case Pr:
      e.value = e.props.join(",");
  }
  return Ee(t = Me(e.children, n)) ? e.return = e.value + "{" + t + "}" : "";
}
function Wn(e) {
  var r = Rr(e);
  return function(t, n, a, i) {
    for (var s = "", u = 0; u < r; u++)
      s += e[u](t, n, a, i) || "";
    return s;
  };
}
function Kn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function Un(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(t) {
    return r[t] === void 0 && (r[t] = e(t)), r[t];
  };
}
var qn = function(r, t, n) {
  for (var a = 0, i = 0; a = i, i = we(), a === 38 && i === 12 && (t[n] = 1), !Ke(i); )
    ue();
  return Ge(r, se);
}, Gn = function(r, t) {
  var n = -1, a = 44;
  do
    switch (Ke(a)) {
      case 0:
        a === 38 && we() === 12 && (t[n] = 1), r[n] += qn(se - 1, t, n);
        break;
      case 2:
        r[n] += er(a);
        break;
      case 4:
        if (a === 44) {
          r[++n] = we() === 58 ? "&\f" : "", t[n] = r[n].length;
          break;
        }
      default:
        r[n] += cr(a);
    }
  while (a = ue());
  return r;
}, Jn = function(r, t) {
  return wt(Gn(Ct(r), t));
}, Qr = /* @__PURE__ */ new WeakMap(), Zn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var t = r.value, n = r.parent, a = r.column === n.column && r.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n)
        return;
    if (!(r.props.length === 1 && t.charCodeAt(0) !== 58 && !Qr.get(n)) && !a) {
      Qr.set(r, !0);
      for (var i = [], s = Jn(t, i), u = n.props, f = 0, m = 0; f < s.length; f++)
        for (var h = 0; h < u.length; h++, m++)
          r.props[m] = i[f] ? s[f].replace(/&\f/g, u[h]) : u[h] + " " + s[f];
    }
  }
}, Xn = function(r) {
  if (r.type === "decl") {
    var t = r.value;
    // charcode for l
    t.charCodeAt(0) === 108 && // charcode for b
    t.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, Qn = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", eo = function(r) {
  return r.type === "comm" && r.children.indexOf(Qn) > -1;
}, ro = function(r) {
  return function(t, n, a) {
    if (!(t.type !== "rule" || r.compat)) {
      var i = t.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var s = !!t.parent, u = s ? t.parent.children : (
          // global rule at the root level
          a
        ), f = u.length - 1; f >= 0; f--) {
          var m = u[f];
          if (m.line < t.line)
            break;
          if (m.column < t.column) {
            if (eo(m))
              return;
            break;
          }
        }
        i.forEach(function(h) {
          console.error('The pseudo class "' + h + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + h.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, St = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, to = function(r, t) {
  for (var n = r - 1; n >= 0; n--)
    if (!St(t[n]))
      return !0;
  return !1;
}, et = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, no = function(r, t, n) {
  St(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), et(r)) : to(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), et(r)));
};
function _t(e, r) {
  switch (kn(e, r)) {
    case 5103:
      return k + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return k + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return k + e + ar + e + te + e + e;
    case 6828:
    case 4268:
      return k + e + te + e + e;
    case 6165:
      return k + e + te + "flex-" + e + e;
    case 5187:
      return k + e + I(e, /(\w+).+(:[^]+)/, k + "box-$1$2" + te + "flex-$1$2") + e;
    case 5443:
      return k + e + te + "flex-item-" + I(e, /flex-|-self/, "") + e;
    case 4675:
      return k + e + te + "flex-line-pack" + I(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return k + e + te + I(e, "shrink", "negative") + e;
    case 5292:
      return k + e + te + I(e, "basis", "preferred-size") + e;
    case 6060:
      return k + "box-" + I(e, "-grow", "") + k + e + te + I(e, "grow", "positive") + e;
    case 4554:
      return k + I(e, /([^-])(transform)/g, "$1" + k + "$2") + e;
    case 6187:
      return I(I(I(e, /(zoom-|grab)/, k + "$1"), /(image-set)/, k + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return I(e, /(image-set\([^]*)/, k + "$1$`$1");
    case 4968:
      return I(I(e, /(.+:)(flex-)?(.*)/, k + "box-pack:$3" + te + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + k + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return I(e, /(.+)-inline(.+)/, k + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Ee(e) - 1 - r > 6)
        switch (X(e, r + 1)) {
          case 109:
            if (X(e, r + 4) !== 45)
              break;
          case 102:
            return I(e, /(.+:)(.+)-([^]+)/, "$1" + k + "$2-$3$1" + ar + (X(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~Er(e, "stretch") ? _t(I(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (X(e, r + 1) !== 115)
        break;
    case 6444:
      switch (X(e, Ee(e) - 3 - (~Er(e, "!important") && 10))) {
        case 107:
          return I(e, ":", ":" + k) + e;
        case 101:
          return I(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + k + (X(e, 14) === 45 ? "inline-" : "") + "box$3$1" + k + "$2$3$1" + te + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (X(e, r + 11)) {
        case 114:
          return k + e + te + I(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return k + e + te + I(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return k + e + te + I(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return k + e + te + e + e;
  }
  return e;
}
var oo = function(r, t, n, a) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case Or:
        r.return = _t(r.value, r.length);
        break;
      case gt:
        return Me([He(r, {
          value: I(r.value, "@", "@" + k)
        })], a);
      case Pr:
        if (r.length)
          return Dn(r.props, function(i) {
            switch (In(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Me([He(r, {
                  props: [I(i, /:(read-\w+)/, ":" + ar + "$1")]
                })], a);
              case "::placeholder":
                return Me([He(r, {
                  props: [I(i, /:(plac\w+)/, ":" + k + "input-$1")]
                }), He(r, {
                  props: [I(i, /:(plac\w+)/, ":" + ar + "$1")]
                }), He(r, {
                  props: [I(i, /:(plac\w+)/, te + "input-$1")]
                })], a);
            }
            return "";
          });
    }
}, ao = [oo], io = function(r) {
  var t = r.key;
  if (process.env.NODE_ENV !== "production" && !t)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (t === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(E) {
      var z = E.getAttribute("data-emotion");
      z.indexOf(" ") !== -1 && (document.head.appendChild(E), E.setAttribute("data-s", ""));
    });
  }
  var a = r.stylisPlugins || ao;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(t))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
  var i = {}, s, u = [];
  s = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
    function(E) {
      for (var z = E.getAttribute("data-emotion").split(" "), $ = 1; $ < z.length; $++)
        i[z[$]] = !0;
      u.push(E);
    }
  );
  var f, m = [Zn, Xn];
  process.env.NODE_ENV !== "production" && m.push(ro({
    get compat() {
      return g.compat;
    }
  }), no);
  {
    var h, x = [Hn, process.env.NODE_ENV !== "production" ? function(E) {
      E.root || (E.return ? h.insert(E.return) : E.value && E.type !== $r && h.insert(E.value + "{}"));
    } : Kn(function(E) {
      h.insert(E);
    })], T = Wn(m.concat(a, x)), b = function(z) {
      return Me(Vn(z), T);
    };
    f = function(z, $, _, v) {
      h = _, process.env.NODE_ENV !== "production" && $.map !== void 0 && (h = {
        insert: function(l) {
          _.insert(l + $.map);
        }
      }), b(z ? z + "{" + $.styles + "}" : $.styles), v && (g.inserted[$.name] = !0);
    };
  }
  var g = {
    key: t,
    sheet: new Pn({
      key: t,
      container: s,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: f
  };
  return g.sheet.hydrate(u), g;
}, wr = { exports: {} }, D = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rt;
function so() {
  if (rt)
    return D;
  rt = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, T = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, z = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function v(l) {
    if (typeof l == "object" && l !== null) {
      var j = l.$$typeof;
      switch (j) {
        case r:
          switch (l = l.type, l) {
            case f:
            case m:
            case n:
            case i:
            case a:
            case x:
              return l;
            default:
              switch (l = l && l.$$typeof, l) {
                case u:
                case h:
                case g:
                case b:
                case s:
                  return l;
                default:
                  return j;
              }
          }
        case t:
          return j;
      }
    }
  }
  function C(l) {
    return v(l) === m;
  }
  return D.AsyncMode = f, D.ConcurrentMode = m, D.ContextConsumer = u, D.ContextProvider = s, D.Element = r, D.ForwardRef = h, D.Fragment = n, D.Lazy = g, D.Memo = b, D.Portal = t, D.Profiler = i, D.StrictMode = a, D.Suspense = x, D.isAsyncMode = function(l) {
    return C(l) || v(l) === f;
  }, D.isConcurrentMode = C, D.isContextConsumer = function(l) {
    return v(l) === u;
  }, D.isContextProvider = function(l) {
    return v(l) === s;
  }, D.isElement = function(l) {
    return typeof l == "object" && l !== null && l.$$typeof === r;
  }, D.isForwardRef = function(l) {
    return v(l) === h;
  }, D.isFragment = function(l) {
    return v(l) === n;
  }, D.isLazy = function(l) {
    return v(l) === g;
  }, D.isMemo = function(l) {
    return v(l) === b;
  }, D.isPortal = function(l) {
    return v(l) === t;
  }, D.isProfiler = function(l) {
    return v(l) === i;
  }, D.isStrictMode = function(l) {
    return v(l) === a;
  }, D.isSuspense = function(l) {
    return v(l) === x;
  }, D.isValidElementType = function(l) {
    return typeof l == "string" || typeof l == "function" || l === n || l === m || l === i || l === a || l === x || l === T || typeof l == "object" && l !== null && (l.$$typeof === g || l.$$typeof === b || l.$$typeof === s || l.$$typeof === u || l.$$typeof === h || l.$$typeof === z || l.$$typeof === $ || l.$$typeof === _ || l.$$typeof === E);
  }, D.typeOf = v, D;
}
var M = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var tt;
function co() {
  return tt || (tt = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, m = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, x = e ? Symbol.for("react.suspense") : 60113, T = e ? Symbol.for("react.suspense_list") : 60120, b = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, E = e ? Symbol.for("react.block") : 60121, z = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function v(y) {
      return typeof y == "string" || typeof y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      y === n || y === m || y === i || y === a || y === x || y === T || typeof y == "object" && y !== null && (y.$$typeof === g || y.$$typeof === b || y.$$typeof === s || y.$$typeof === u || y.$$typeof === h || y.$$typeof === z || y.$$typeof === $ || y.$$typeof === _ || y.$$typeof === E);
    }
    function C(y) {
      if (typeof y == "object" && y !== null) {
        var je = y.$$typeof;
        switch (je) {
          case r:
            var Ne = y.type;
            switch (Ne) {
              case f:
              case m:
              case n:
              case i:
              case a:
              case x:
                return Ne;
              default:
                var Oe = Ne && Ne.$$typeof;
                switch (Oe) {
                  case u:
                  case h:
                  case g:
                  case b:
                  case s:
                    return Oe;
                  default:
                    return je;
                }
            }
          case t:
            return je;
        }
      }
    }
    var l = f, j = m, P = u, ge = s, ae = r, V = h, me = n, ye = g, S = b, Z = t, Q = i, ie = a, le = x, fe = !1;
    function de(y) {
      return fe || (fe = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), U(y) || C(y) === f;
    }
    function U(y) {
      return C(y) === m;
    }
    function Y(y) {
      return C(y) === u;
    }
    function ee(y) {
      return C(y) === s;
    }
    function re(y) {
      return typeof y == "object" && y !== null && y.$$typeof === r;
    }
    function pe(y) {
      return C(y) === h;
    }
    function H(y) {
      return C(y) === n;
    }
    function W(y) {
      return C(y) === g;
    }
    function J(y) {
      return C(y) === b;
    }
    function ne(y) {
      return C(y) === t;
    }
    function xe(y) {
      return C(y) === i;
    }
    function Ae(y) {
      return C(y) === a;
    }
    function pr(y) {
      return C(y) === x;
    }
    M.AsyncMode = l, M.ConcurrentMode = j, M.ContextConsumer = P, M.ContextProvider = ge, M.Element = ae, M.ForwardRef = V, M.Fragment = me, M.Lazy = ye, M.Memo = S, M.Portal = Z, M.Profiler = Q, M.StrictMode = ie, M.Suspense = le, M.isAsyncMode = de, M.isConcurrentMode = U, M.isContextConsumer = Y, M.isContextProvider = ee, M.isElement = re, M.isForwardRef = pe, M.isFragment = H, M.isLazy = W, M.isMemo = J, M.isPortal = ne, M.isProfiler = xe, M.isStrictMode = Ae, M.isSuspense = pr, M.isValidElementType = v, M.typeOf = C;
  }()), M;
}
process.env.NODE_ENV === "production" ? wr.exports = so() : wr.exports = co();
var uo = wr.exports, Tt = uo, lo = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, fo = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, $t = {};
$t[Tt.ForwardRef] = lo;
$t[Tt.Memo] = fo;
var po = !0;
function ho(e, r, t) {
  var n = "";
  return t.split(" ").forEach(function(a) {
    e[a] !== void 0 ? r.push(e[a] + ";") : n += a + " ";
  }), n;
}
var Pt = function(r, t, n) {
  var a = r.key + "-" + t.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  po === !1) && r.registered[a] === void 0 && (r.registered[a] = t.styles);
}, vo = function(r, t, n) {
  Pt(r, t, n);
  var a = r.key + "-" + t.name;
  if (r.inserted[t.name] === void 0) {
    var i = t;
    do
      r.insert(t === i ? "." + a : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function mo(e) {
  for (var r = 0, t, n = 0, a = e.length; a >= 4; ++n, a -= 4)
    t = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, t = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), t ^= /* k >>> r: */
    t >>> 24, r = /* Math.imul(k, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (a) {
    case 3:
      r ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(n) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var yo = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, nt = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, bo = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", go = /[A-Z]|^ms/g, Ot = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Ar = function(r) {
  return r.charCodeAt(1) === 45;
}, ot = function(r) {
  return r != null && typeof r != "boolean";
}, gr = /* @__PURE__ */ Un(function(e) {
  return Ar(e) ? e : e.replace(go, "-$&").toLowerCase();
}), ir = function(r, t) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof t == "string")
        return t.replace(Ot, function(n, a, i) {
          return be = {
            name: a,
            styles: i,
            next: be
          }, a;
        });
  }
  return yo[r] !== 1 && !Ar(r) && typeof t == "number" && t !== 0 ? t + "px" : t;
};
if (process.env.NODE_ENV !== "production") {
  var xo = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, Eo = ["normal", "none", "initial", "inherit", "unset"], Co = ir, wo = /^-ms-/, So = /-(.)/g, at = {};
  ir = function(r, t) {
    if (r === "content" && (typeof t != "string" || Eo.indexOf(t) === -1 && !xo.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || t.charAt(0) !== '"' && t.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = Co(r, t);
    return n !== "" && !Ar(r) && r.indexOf("-") !== -1 && at[r] === void 0 && (at[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(wo, "ms-").replace(So, function(a, i) {
      return i.toUpperCase();
    }) + "?")), n;
  };
}
var Rt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Ue(e, r, t) {
  if (t == null)
    return "";
  if (t.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && t.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(Rt);
    return t;
  }
  switch (typeof t) {
    case "boolean":
      return "";
    case "object": {
      if (t.anim === 1)
        return be = {
          name: t.name,
          styles: t.styles,
          next: be
        }, t.name;
      if (t.styles !== void 0) {
        var n = t.next;
        if (n !== void 0)
          for (; n !== void 0; )
            be = {
              name: n.name,
              styles: n.styles,
              next: be
            }, n = n.next;
        var a = t.styles + ";";
        return process.env.NODE_ENV !== "production" && t.map !== void 0 && (a += t.map), a;
      }
      return _o(e, r, t);
    }
    case "function": {
      if (e !== void 0) {
        var i = be, s = t(e);
        return be = i, Ue(e, r, s);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var u = [], f = t.replace(Ot, function(h, x, T) {
          var b = "animation" + u.length;
          return u.push("const " + b + " = keyframes`" + T.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + b + "}";
        });
        u.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(u, ["`" + f + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + f + "`"));
      }
      break;
  }
  if (r == null)
    return t;
  var m = r[t];
  return m !== void 0 ? m : t;
}
function _o(e, r, t) {
  var n = "";
  if (Array.isArray(t))
    for (var a = 0; a < t.length; a++)
      n += Ue(e, r, t[a]) + ";";
  else
    for (var i in t) {
      var s = t[i];
      if (typeof s != "object")
        r != null && r[s] !== void 0 ? n += i + "{" + r[s] + "}" : ot(s) && (n += gr(i) + ":" + ir(i, s) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(Rt);
        if (Array.isArray(s) && typeof s[0] == "string" && (r == null || r[s[0]] === void 0))
          for (var u = 0; u < s.length; u++)
            ot(s[u]) && (n += gr(i) + ":" + ir(i, s[u]) + ";");
        else {
          var f = Ue(e, r, s);
          switch (i) {
            case "animation":
            case "animationName": {
              n += gr(i) + ":" + f + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(bo), n += i + "{" + f + "}";
          }
        }
      }
    }
  return n;
}
var it = /label:\s*([^\s;\n{]+)\s*(;|$)/g, At;
process.env.NODE_ENV !== "production" && (At = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var be, st = function(r, t, n) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var a = !0, i = "";
  be = void 0;
  var s = r[0];
  s == null || s.raw === void 0 ? (a = !1, i += Ue(n, t, s)) : (process.env.NODE_ENV !== "production" && s[0] === void 0 && console.error(nt), i += s[0]);
  for (var u = 1; u < r.length; u++)
    i += Ue(n, t, r[u]), a && (process.env.NODE_ENV !== "production" && s[u] === void 0 && console.error(nt), i += s[u]);
  var f;
  process.env.NODE_ENV !== "production" && (i = i.replace(At, function(T) {
    return f = T, "";
  })), it.lastIndex = 0;
  for (var m = "", h; (h = it.exec(i)) !== null; )
    m += "-" + // $FlowFixMe we know it's not null
    h[1];
  var x = mo(i) + m;
  return process.env.NODE_ENV !== "production" ? {
    name: x,
    styles: i,
    map: f,
    next: be,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: x,
    styles: i,
    next: be
  };
}, To = function(r) {
  return r();
}, $o = Te["useInsertionEffect"] ? Te["useInsertionEffect"] : !1, Po = $o || To, fr = {}.hasOwnProperty, Nr = /* @__PURE__ */ Te.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ io({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Nr.displayName = "EmotionCacheContext");
Nr.Provider;
var Oo = function(r) {
  return /* @__PURE__ */ qe(function(t, n) {
    var a = yn(Nr);
    return r(t, a, n);
  });
}, Nt = /* @__PURE__ */ Te.createContext({});
process.env.NODE_ENV !== "production" && (Nt.displayName = "EmotionThemeContext");
var ct = function(r) {
  var t = r.split(".");
  return t[t.length - 1];
}, Ro = function(r) {
  var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (t || (t = /^([A-Za-z0-9$.]+)@/.exec(r), t))
    return ct(t[1]);
}, Ao = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), No = function(r) {
  return r.replace(/\$/g, "-");
}, ko = function(r) {
  if (r)
    for (var t = r.split(`
`), n = 0; n < t.length; n++) {
      var a = Ro(t[n]);
      if (a) {
        if (Ao.has(a))
          break;
        if (/^[A-Z]/.test(a))
          return No(a);
      }
    }
}, Sr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", _r = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", kt = function(r, t) {
  if (process.env.NODE_ENV !== "production" && typeof t.css == "string" && // check if there is a css declaration
  t.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
  var n = {};
  for (var a in t)
    fr.call(t, a) && (n[a] = t[a]);
  if (n[Sr] = r, process.env.NODE_ENV !== "production" && t.css && (typeof t.css != "object" || typeof t.css.name != "string" || t.css.name.indexOf("-") === -1)) {
    var i = ko(new Error().stack);
    i && (n[_r] = i);
  }
  return n;
}, Io = function(r) {
  var t = r.cache, n = r.serialized, a = r.isStringTag;
  return Pt(t, n, a), Po(function() {
    return vo(t, n, a);
  }), null;
}, It = /* @__PURE__ */ Oo(function(e, r, t) {
  var n = e.css;
  typeof n == "string" && r.registered[n] !== void 0 && (n = r.registered[n]);
  var a = e[Sr], i = [n], s = "";
  typeof e.className == "string" ? s = ho(r.registered, i, e.className) : e.className != null && (s = e.className + " ");
  var u = st(i, void 0, Te.useContext(Nt));
  if (process.env.NODE_ENV !== "production" && u.name.indexOf("-") === -1) {
    var f = e[_r];
    f && (u = st([u, "label:" + f + ";"]));
  }
  s += r.key + "-" + u.name;
  var m = {};
  for (var h in e)
    fr.call(e, h) && h !== "css" && h !== Sr && (process.env.NODE_ENV === "production" || h !== _r) && (m[h] = e[h]);
  return m.ref = t, m.className = s, /* @__PURE__ */ Te.createElement(Te.Fragment, null, /* @__PURE__ */ Te.createElement(Io, {
    cache: r,
    serialized: u,
    isStringTag: typeof a == "string"
  }), /* @__PURE__ */ Te.createElement(a, m));
});
process.env.NODE_ENV !== "production" && (It.displayName = "EmotionCssPropInternal");
var Dt = It;
function A(e, r, t) {
  return fr.call(r, "css") ? or.jsx(Dt, kt(e, r), t) : or.jsx(e, r, t);
}
function Pe(e, r, t) {
  return fr.call(r, "css") ? or.jsxs(Dt, kt(e, r), t) : or.jsxs(e, r, t);
}
const Mt = (e) => {
  const { title: r, tabKey: t, isSelected: n, disabled: a, handleSelectTab: i, size: s = "medium", variant: u, closable: f, tabPosition: m, deleteIcon: h = A(Cn, { size: "8" }), handleDeleteTab: x, tabBarSpacing: T, colorScheme: b } = e, g = ce(() => {
    let E;
    return u === "card" ? E = aa(n, a, m) : u === "capsule" ? E = na(n, a) : E = kr(), E;
  }, [a, n, m, u]);
  return A("span", { css: g, onClick: () => {
    a || i(t);
  }, children: Pe("span", { css: la(b, s, n, a, T, u), children: [r, f && A("span", { css: ca, onClick: (E) => {
    x && x(t), E.stopPropagation();
  }, children: h })] }) }, t);
};
var Lt = {}, ve = {};
Object.defineProperty(ve, "__esModule", { value: !0 });
ve.isNavigator = ve.isBrowser = ve.off = ve.on = ve.noop = void 0;
var Do = function() {
};
ve.noop = Do;
function Mo(e) {
  for (var r = [], t = 1; t < arguments.length; t++)
    r[t - 1] = arguments[t];
  e && e.addEventListener && e.addEventListener.apply(e, r);
}
ve.on = Mo;
function Lo(e) {
  for (var r = [], t = 1; t < arguments.length; t++)
    r[t - 1] = arguments[t];
  e && e.removeEventListener && e.removeEventListener.apply(e, r);
}
ve.off = Lo;
ve.isBrowser = typeof window < "u";
ve.isNavigator = typeof navigator < "u";
Object.defineProperty(Lt, "__esModule", { value: !0 });
var ut = Tr, lt = ve, Fo = function(e) {
  var r = ut.useState(!1), t = r[0], n = r[1];
  return ut.useEffect(function() {
    if (e.current) {
      var a, i = function() {
        n(!1);
      }, s = function() {
        n(!0), clearTimeout(a), a = setTimeout(function() {
          return i();
        }, 150);
      };
      return lt.on(e.current, "scroll", s, !1), function() {
        e.current && lt.off(e.current, "scroll", s, !1);
      };
    }
    return function() {
    };
  }, [e]), t;
}, Ft = Lt.default = Fo;
const ft = 16;
function _e(e, r) {
  if (!r)
    return [];
  let t;
  return e ? t = r ? zo(r) : [] : t = r ? jo(r) : [], t;
}
const zt = qe((e, r) => {
  const { tabHeaderChild: t, selectedIndex: n = -1, size: a = "medium", tabPosition: i, handleSelectTab: s, tabBarSpacing: u, suffix: f, prefix: m, variant: h, align: x, colorScheme: T = "blue" } = e, b = tr(null), g = tr(null), E = Ft(b), [z, { width: $, height: _ }] = bt({
    polyfill: ResizeObserver
  }), [v, C] = Ce(!1), [l, j] = Ce(!1), [P, ge] = Ce(!1), [ae, V] = Ce(0), [me, ye] = Ce(ft), [S, Z] = ce(() => [dr(i), dt(i)], [i]);
  De(() => {
    if (V(() => _e(S, g.current)[n]), !(b != null && b.current))
      return;
    const H = _e(S, g.current);
    let W = 0;
    for (let J = 0; J < n; J++)
      W += H[J];
    W = S ? W : W + ft, ye(W);
  }, [
    n,
    u,
    g,
    t,
    S
  ]);
  const Q = Le((H, W) => {
    var ne, xe;
    const J = jt(_e(S, g.current), $e(S, b), Re(S, b), W);
    S ? (ne = b.current) == null || ne.scrollTo(0, J) : (xe = b.current) == null || xe.scrollTo(J, 0), s(H);
  }, [S, s]), ie = Le(() => {
    b.current && (C(Re(S, b) === 0), j(Math.abs(Re(S, b) + $e(S, b) - Bt(S, b)) === 0));
  }, [S]);
  De(() => {
    E || ie();
  }, [E, P, ie]), De(() => {
    V(() => _e(S, g.current)[n]);
  }, [S, n]), De(() => {
    var J;
    if (!(b != null && b.current))
      return;
    const H = (J = _e(S, g.current)) == null ? void 0 : J.reduce((ne, xe) => ne + xe, 0), W = $e(S, b);
    ge(H - W > 1);
  }, [S, $, _, t == null ? void 0 : t.length]);
  const le = ce(() => {
    const H = _e(S, g.current);
    let W = 0;
    const J = H == null ? void 0 : H.length;
    for (let ne = 0; ne < J; ne++)
      W += H[ne];
    return W > $e(S, b) ? W : $e(S, b);
  }, [S]);
  let [fe, de, U, Y, ee] = S ? [
    Xo,
    Zo,
    da,
    ha,
    Wt,
    ba(i === "left")
  ] : [
    Yt,
    Uo,
    fa,
    pa,
    Kt,
    ga(i === "top")
  ];
  const [re, pe] = ce(() => S ? [A(ht, {}, "upIcon"), A(vt, {}, "downIcon")] : [A(mt, {}, "preIcon"), A(yt, {}, "nextIcon")], [S]);
  return Pe("div", { css: Vt(h, i, x), ref: r, children: [m, Pe("div", { css: Ut, ref: z, children: [P && A("span", { onClick: () => {
    sr(!0, v, S, b, g, ie);
  }, css: ee(!0, "line", v), children: re }), A("div", { ref: b, css: Ht(S), children: Pe("div", { css: fe, ref: r, children: [!Z && A("div", { css: U(g && le), children: A("div", { css: Y(ae, me, T, a) }) }), A("div", { ref: g, css: de, children: t && (t == null ? void 0 : t.map((H, W) => A(Mt, { handleSelectTab: (J) => {
    Q(J, W);
  }, title: H.title, tabKey: H.tabKey, isSelected: W === n, disabled: H.disabled, size: a, tabBarSpacing: u, colorScheme: T }, H.tabKey))) }), dt(i) && A("div", { css: U(g && le), children: A("div", { css: Y(ae, me, T, a) }) })] }) }), P && A("span", { onClick: () => {
    sr(!1, l, S, b, g, ie);
  }, css: ee(!1, "line", l), children: pe })] }), f] });
});
zt.displayName = "TabLineHeader";
const dr = (e) => e === "left" || e === "right", dt = (e) => e === "top" || e === "left";
function zo(e) {
  var a;
  const r = e.children, t = (r == null ? void 0 : r.length) ?? 0, n = [];
  for (let i = 0; i < t; i++)
    n.push(((a = r == null ? void 0 : r.item(i)) == null ? void 0 : a.clientHeight) ?? 0);
  return n;
}
function jo(e) {
  var a;
  if (!e)
    return [];
  const r = e.children, t = (r == null ? void 0 : r.length) ?? 0, n = [];
  for (let i = 0; i < t; i++)
    n.push(((a = r == null ? void 0 : r.item(i)) == null ? void 0 : a.clientWidth) ?? 0);
  return n;
}
const Bo = (e, r, t) => {
  let n = 0;
  const a = e.length;
  if (t == 0) {
    let i;
    for (i = 0; i < a && n < r; i++)
      n += e[i];
    return n - e[i - 1];
  } else {
    let i, s;
    for (i = 0; i < a && n < t; i++)
      n += e[i];
    let u = 0;
    for (s = i + 1; s < a && u < r; s++)
      u += e[s];
    return n + u - e[s - 1];
  }
}, Vo = (e, r, t) => {
  let n;
  const a = e.length, i = t - r;
  let s = 0;
  for (n = 0; n < a && s < i; n++)
    s += e[n];
  return s - e[n - 1];
}, jt = (e, r, t, n) => {
  let a = 0, i = 0;
  for (; i < n; i++)
    a += e[i];
  return a + e[i] > t + r ? a + e[i] - r : a < t ? a : t;
}, $e = (e, r) => {
  var t, n;
  return (e ? (t = r == null ? void 0 : r.current) == null ? void 0 : t.offsetHeight : (n = r == null ? void 0 : r.current) == null ? void 0 : n.offsetWidth) ?? 0;
}, Bt = (e, r) => {
  var t, n;
  return (e ? (t = r == null ? void 0 : r.current) == null ? void 0 : t.scrollHeight : (n = r == null ? void 0 : r.current) == null ? void 0 : n.scrollWidth) ?? 0;
}, Re = (e, r) => {
  var t, n;
  return (e ? (t = r == null ? void 0 : r.current) == null ? void 0 : t.scrollTop : (n = r == null ? void 0 : r.current) == null ? void 0 : n.scrollLeft) ?? 0;
}, sr = (e, r, t, n, a, i) => {
  var f, m;
  if (r || !n || !(n != null && n.current))
    return;
  let u = (e ? Vo : Bo)(_e(t, a.current), $e(t, n), Re(t, n));
  t ? (f = n.current) == null || f.scrollTo(0, u) : (m = n.current) == null || m.scrollTo(u, 0), i == null || i();
};
function Yo(e) {
  let r;
  switch (e) {
    case "large":
      r = p`
        margin: 8px 0;
      `;
      break;
    case "small":
      r = p`
        margin: 4px 0;
      `;
      break;
    default:
      r = p`
        margin: 6px 0;
      `;
  }
  return r;
}
function Ho(e) {
  return p`
    width: 100%;
    display: flex;
    flex-direction: ${e === "bottom" ? "column-reverse" : "column"};
  `;
}
function Wo(e) {
  return p`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: ${e === "right" ? "row-reverse" : "row"};
  `;
}
function Ko(e) {
  return dr(e) ? Wo(e) : Ho(e);
}
const Uo = p`
  display: inline-flex;
  width: 100%;
  align-items: center;
`;
function qo(e) {
  return e === "bottom" ? p`
        border-top: solid ${L(`--${F}-grayBlue-08`)} 1px;
      ` : p`
        border-bottom: solid ${L(`--${F}-grayBlue-08`)} 1px;
      `;
}
function Go(e, r) {
  const t = qo(r), n = r === "left" || r === "right" ? p`
          flex-direction: column;
        ` : p``;
  return p`
    display: inline-flex;
    width: 100%;
    align-items: center;
    ${e === "card" ? t : ""}
    ${e === "text" ? n : ""}
  `;
}
function Jo(e) {
  let r;
  switch (e) {
    case "bottom": {
      r = p`
        border-top: solid ${L(`--${F}-grayBlue-08`)} 1px;
        align-items: start;
      `;
      break;
    }
    case "left": {
      r = p`
        border-right: solid ${L(`--${F}-grayBlue-08`)} 1px;
        align-items: end;
      `;
      break;
    }
    case "right": {
      r = p`
        border-left: solid ${L(`--${F}-grayBlue-08`)} 1px;
        align-items: start;
      `;
      break;
    }
    default: {
      r = p`
        border-bottom: solid ${L(`--${F}-grayBlue-08`)} 1px;
        align-items: end;
      `;
      break;
    }
  }
  return r;
}
function Vt(e, r, t) {
  const n = dr(r);
  let a = p``;
  return e === "line" && (a = Jo(r)), p`
    display: inline-flex;
    flex-direction: ${n ? "column" : "row"};
    align-items: end;
    justify-content: ${t};
    ${a};
  `;
}
const Zo = p`
  display: inline-flex;
  flex-direction: column;
`, Yt = p`
  display: inline-flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
`, Xo = p`
  display: inline-flex;
  flex-direction: row;
  flex-grow: 1;
`, Qo = p`
  display: inline-flex;
  flex-direction: column;
  background-color: ${L(`--${F}-grayBlue-09`)};
  border-radius: 4px;
  padding: 0 2px;
  margin-bottom: 10px;
`, ea = p`
  overflow-x: auto;
  overflow-y: hidden;
  scroll-behavior: smooth;
  width: 100%;
  height: 100%;
  display: inline-flex;

  position: relative;

  ::-webkit-scrollbar {
    display: none;
  }

  /* Chrome Safari */
  -ms-overflow-style: none;
  box-sizing: border-box;
`, ra = p`
  overflow-y: scroll;
  height: 100%;
  position: relative;

  ::-webkit-scrollbar {
    display: none;
  }

  /* Chrome Safari */
  -ms-overflow-style: none;

  box-sizing: border-box;
`;
function Ht(e) {
  return e ? ra : ea;
}
const ta = p`
  display: inline-flex;
  flex-direction: column;
  box-sizing: border-box;
`;
function na(e, r) {
  const t = e && p`
      background-color: ${L(`--${F}-white-01`)};
      border-radius: 4px;
      transition: background-color 200ms;
    `;
  return p`
    ${kr()};
    ${t};
    margin: 4px 2px;
    border-radius: 4px;
    ${oa(e, r)}
    transition: background-color 200ms;
  `;
}
function oa(e, r) {
  if (!e && !r)
    return p`
      &:hover {
        background-color: ${L(`--${F}-white-01`)};
      }
    `;
}
function aa(e, r, t) {
  const n = e ? p`
        border: solid ${L(`--${F}-grayBlue-08`)};
        ${t === "bottom" ? "border-top: solid white;" : "border-bottom: solid white;"};
      ` : p`
        border: solid transparent;
      `;
  return p`
    position: relative;
    ${t === "bottom" ? p`
          border-radius: 0 0 4px 4px;
          bottom: 1px;
        ` : p`
          border-radius: 4px 4px 0 0;
          top: 1px;
        `};
    ${kr()};
    ${n};
    border-width: 1px;
    border-bottom-width: 1.5px;
    z-index: ${gn.tabs};
    margin: 0 2px;
    ${ia(e, r)}
    color: ${L(`--${F}-grayBlue-03`)};
    transition: background-color 200ms;
  `;
}
function ia(e, r) {
  if (!e && !r)
    return p`
      &:hover {
        background-color: ${L(`--${F}-grayBlue-09`)};
      }
    `;
}
const sa = p`
  height: 100%;
  padding: 0 10px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: ${L(`--${F}-grayBlue-05`)};

  &:hover {
    color: ${L(`--${F}-grayBlue-02`)};
  }
`, ca = p`
  height: 100%;
  padding: 4px;
  margin-left: 8px;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: ${L(`--${F}-grayBlue-05`)};

  &:hover {
    color: ${L(`--${F}-grayBlue-02`)};
  }
`;
function kr() {
  return p`
    display: inline-flex;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  `;
}
function ua(e, r, t, n) {
  let a;
  return r ? a = p`
      color: ${L(`--${F}-grayBlue-05`)};
      cursor: not-allowed;
    ` : t ? a = p`
      color: ${nr(e, "02")};
    ` : a = p`
      color: ${L(`--${F}-grayBlue-03`)};

      &:hover {
        background-color: ${n !== "capsule" ? L(`--${F}-grayBlue-09`) : void 0};
      }
    `, !r && n === "text" && (t ? a = p`
        color: ${nr(e, "02")};
        font-weight: 500;
      ` : a = p`
        color: ${L(`--${F}-grayBlue-03`)};

        &:hover {
          background-color: ${L(`--${F}-gray-09`)};
        }
      `), a;
}
function la(e, r, t, n, a = 0, i) {
  const s = a >= 0 ? a : 0;
  return p`
    ${ua(e, n, t, i)};
    ${Yo(r)};
    white-space: nowrap;
    font-weight: ${t ? 500 : 400};
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    padding: 1px 8px;
    line-height: 22px;
    border-radius: 4px;
    margin-left: ${8 + s / 2}px;
    margin-right: ${8 + s / 2}px;
    transition: color 200ms, background-color 200ms;
  `;
}
function fa(e) {
  return p`
    width: ${e}px;
    display: inline-flex;
    position: relative;
  `;
}
function da(e) {
  return p`
    height: ${e}px;
    display: inline-flex;
  `;
}
function pa(e, r, t) {
  return p`
    width: ${e - 32}px;
    height: 2px;
    position: relative;
    box-sizing: border-box;
    left: ${r}px;
    bottom: 0;
    transition: left 200ms, width 200ms;
    background-color: ${nr(t, "02")};
  `;
}
function ha(e, r, t, n) {
  let a = 7;
  switch (n) {
    case "large":
      a = 9;
      break;
    case "small":
      a = 5;
      break;
  }
  return p`
    width: 2px;
    height: ${e - a * 2}px;
    position: relative;
    box-sizing: border-box;
    top: ${a + r}px;
    transition: top 200ms, height 200ms;
    bottom: 0;
    background-color: ${nr(t, "03")};
  `;
}
p`
  width: 100%;
  display: inline-flex;
  position: relative;
  border-top: solid ${L(`--${F}-grayBlue-08`)} 1px;
`;
const Ir = p`
  display: inline-flex;
  flex-direction: row;
  overflow: hidden;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
`;
p`
  ${Ir};
  border: solid 1px ${L(`--${F}-grayBlue-08`)};
  border-top: 0;
`;
function va(e) {
  const r = e === "bottom" ? p`
          border-bottom: 0;
        ` : p`
          border-top: 0;
        `;
  return p`
    border: solid 1px ${L(`--${F}-grayBlue-08`)};
    ${Ir};
    ${r};
  `;
}
function ma(e, r) {
  const t = r === !0 ? p`
          transition: right 200ms;
        ` : p``, n = e * 100;
  return p`
    width: 100%;
    height: 100%;
    right: ${n}%;
    ${t};
    position: relative;
    display: inline-flex;
    flex-direction: row;
  `;
}
const ya = p`
  display: inline-flex;
  flex-grow: 2;
  flex: none;
  width: 100%;
`;
function Wt(e, r, t) {
  let n;
  e ? n = p`
      padding-bottom: 4px;
    ` : n = p`
      padding-top: 4px;
    `;
  let a = t && p`
      cursor: not-allowed;
    `;
  return p`
    display: inline-flex;
    font-size: 12px;
    cursor: pointer;
    ${n}
    ${a}
    position: relative;
    width: 100%;
    justify-content: center;
  `;
}
function Kt(e, r, t, n) {
  let a = t && p`
      cursor: not-allowed;
    `, i = r === "card" ? n === "bottom" ? p`
            top: 0.5px;
            border-top: solid ${L(`--${F}-grayBlue-08`)} 1px;
          ` : p`
            top: -0.5px;
            border-bottom: solid ${L(`--${F}-grayBlue-08`)}
              1px;
          ` : "";
  return p`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 12px;
    text-align: center;
    position: relative;
    padding: 0 12px ${r === "capsule" ? 11 : 0}px 4px;
    ${i};
    ${a};
  `;
}
function pt(e) {
  return e ? Wt : Kt;
}
function ba(e) {
  const r = e ? p`
        right: 0;
      ` : p`
        left: 2px;
      `;
  return p`
    height: 100%;
    width: 1px;
    position: absolute;
    ${r};
    top: 0;
    background-color: ${L(`--${F}-grayBlue-08`)};
  `;
}
function ga(e) {
  const r = e ? p`
        bottom: 4px;
      ` : p`
        top: 6.5px;
      `;
  return p`
    height: 0.5px;
    width: 100%;
    position: absolute;
    ${r};
    left: 0;
    background-color: ${L(`--${F}-grayBlue-08`)};
  `;
}
const Ut = p`
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  flex-direction: inherit;
  height: 100%;
`, qt = qe((e, r) => {
  const { children: t } = e;
  return A("div", { css: ya, ref: r, children: t });
});
qt.displayName = "TabPane";
const xa = (e) => {
  const { tabPanes: r, animated: t, selectedIndex: n = 0, variant: a, tabPosition: i } = e;
  return A("div", { css: a === "card" ? va(i) : Ir, children: A("div", { css: ma(n, t), children: r && (r == null ? void 0 : r.map((s) => s)) }) });
}, Gt = qe((e, r) => {
  const { tabHeaderChild: t, selectedIndex: n, variant: a, editable: i, onAddTab: s, deleteIcon: u, size: f = "medium", handleSelectTab: m, handleDeleteTab: h, tabBarSpacing: x, prefix: T, suffix: b, tabPosition: g, align: E, colorScheme: z = "blue", addIcon: $ = A(wn, {}) } = e, _ = ce(() => a == "capsule" ? Qo : a === "card" ? ta : Yt, [a]), v = dr(g), C = tr(null), l = tr(null), j = Ft(C), [P, { width: ge, height: ae }] = bt({
    polyfill: ResizeObserver
  }), [V, me] = Ce(!0), [ye, S] = Ce(!1), [Z, Q] = Ce(!1), ie = Le((Y, ee) => {
    var pe, H;
    const re = jt(_e(v, l.current), $e(v, C), Re(v, C), ee);
    v ? (pe = C.current) == null || pe.scrollTo(0, re) : (H = C.current) == null || H.scrollTo(re, 0), m(Y);
  }, [v, m]), le = Le(() => {
    C.current && (me(Re(v, C) === 0), S(Math.abs(Re(v, C) + $e(v, C) - Bt(v, C)) < 1));
  }, [v]);
  De(() => {
    j || le();
  }, [j, Z, le]), De(() => {
    var re;
    if (!(C != null && C.current))
      return;
    const Y = (re = _e(v, l.current)) == null ? void 0 : re.reduce((pe, H) => pe + H, 0), ee = $e(v, C);
    Q(Y > ee);
  }, [v, ge, ae, t == null ? void 0 : t.length]);
  const [fe, de] = ce(() => v ? [A(ht, {}, "upIcon"), A(vt, {}, "downIcon")] : [
    A(mt, {}, "previousIcon"),
    A(yt, {}, "nextIcon")
  ], [v]), U = ce(() => t && (t == null ? void 0 : t.map((Y, ee) => {
    const re = {
      handleSelectTab: (pe) => ie(pe, ee),
      title: Y.title,
      tabKey: Y.tabKey,
      isSelected: ee == n,
      disabled: Y.disabled,
      size: f,
      variant: a,
      closable: a === "card" && i,
      deleteIcon: u,
      handleDeleteTab: h,
      tabBarSpacing: x,
      colorScheme: z,
      tabPosition: g
    };
    return A(Mt, { ...re }, Y.tabKey);
  })), [
    ie,
    z,
    u,
    i,
    h,
    n,
    f,
    x,
    t,
    g,
    a
  ]);
  return Pe("div", { css: Vt(a, g, E), ref: r, children: [T, Pe("div", { css: Ut, ref: P, children: [Z && A("span", { onClick: () => {
    sr(!0, V, v, C, l);
  }, css: pt(v)(!0, a, V, g), children: fe }), A("div", { ref: C, css: Ht(v), children: A("div", { css: _, children: Pe("div", { ref: l, css: Go(a, g), children: [U, a === "card" && i && A("span", { css: sa, onClick: () => {
    s && s();
  }, children: $ })] }) }) }), Z && A("span", { onClick: () => {
    sr(!1, ye, v, C, l);
  }, css: pt(v)(!1, a, ye, g), children: de })] }), b] });
});
Gt.displayName = "TabCommonHeader";
function Ea(e) {
  const r = [], t = [];
  let n;
  return bn.forEach(e, (a, i) => {
    var s;
    if (a && a.type && a && a.props && a.props && a.props.title) {
      const u = a.props, f = ((s = a == null ? void 0 : a.key) == null ? void 0 : s.toString()) ?? u.title + i;
      n || (n = f), r.push({
        ...u,
        tabKey: f
      }), t.push(A(qt, { ...u }, f));
    }
  }), {
    headers: r,
    panes: t,
    firstTabKey: n
  };
}
function Ca(e, r) {
  var a;
  if (e < 0)
    return r;
  const t = [...r.headers];
  t.splice(e, 1);
  const n = [...r.panes];
  return n.splice(e, 1), {
    headers: t,
    panes: n,
    firstTabKey: ((a = t[0]) == null ? void 0 : a.tabKey) ?? ""
  };
}
function wa(e, r) {
  return r ? r.findIndex((t) => e === t.tabKey) : -1;
}
const Sa = qe((e, r) => {
  const { children: t, placeholder: n, defaultActiveKey: a, size: i = "medium", animated: s, editable: u, variant: f = "line", addIcon: m, deleteIcon: h, tabBarSpacing: x, tabPosition: T = "top", align: b = "flex-start", activeKey: g, prefix: E, suffix: z, colorScheme: $, withoutContent: _ = !1, onChange: v, onAddTab: C, onDeleteTab: l, onClickTab: j, ...P } = e, [ge, ae] = Ce(a), [V, me] = Ce({
    headers: [],
    panes: []
  });
  ce(() => {
    const U = Ea(t);
    me(U), a || ae(U.firstTabKey);
  }, [t, a]);
  const ye = ce(() => {
    if (typeof s == "boolean")
      return s;
    if (qr(s))
      return s.inkBar ?? !0;
  }, [s]), S = ce(() => {
    if (typeof s == "boolean")
      return s;
    if (qr(s))
      return s.tabPane ?? !1;
  }, [s]), Z = ce(() => g ?? ge, [g, ge]), Q = ce(() => wa(Z, V.headers), [Z, V]), ie = Le((U) => {
    const Y = V.headers.findIndex((re) => re.tabKey === U);
    Y === Q && (Y === V.headers.length - 1 ? (ae(V.headers[Y - 1].tabKey), v && v(V.headers[Y - 1].tabKey)) : (ae(V.headers[Y + 1].tabKey), v && v(V.headers[Y + 1].tabKey)));
    const ee = Ca(Y, V);
    me(ee), l && l(U);
  }, [V, Q, v, l]), le = Le((U) => {
    j && j(U), ae(U), v && v(U);
  }, [v, j]), fe = {
    selectedIndex: Q,
    animated: ye,
    tabHeaderChild: V == null ? void 0 : V.headers,
    handleSelectTab: le,
    size: i,
    align: b,
    variant: f,
    editable: u,
    addIcon: m,
    onAddTab: C,
    tabBarSpacing: x,
    tabPosition: T,
    handleDeleteTab: ie,
    deleteIcon: h,
    suffix: z,
    prefix: E,
    colorScheme: $
  }, de = ce(() => f === "capsule" && T !== "top" || f === "card" && (T === "left" || T === "right") ? "line" : f, [f, T]);
  return Pe("div", { css: [Ko(T), xn(e)], placeholder: n, ref: r, ...En(P), children: [de === "line" && A(zt, { ...fe }), de != "line" && A(Gt, { ...fe }), !_ && A(xa, { animated: S, tabPanes: V == null ? void 0 : V.panes, selectedIndex: Q, variant: de, tabPosition: T })] });
});
Sa.displayName = "Tabs";
export {
  qt as TabPane,
  Sa as Tabs
};
//# sourceMappingURL=index.js.map
